import type {
  FooterAccordion as FooterAccordionSchema,
  Link,
  LocalizedValue,
} from '@amplience/content-types/typings/c-footer-accordion';
import { LinkPartial } from '../../../partials/link';
import { getLocalizedValue } from '../../../utils/transformers';
import { MobileFooterAccordion } from '../mobileFooterAccordion/MobileFooterAccordion';
import {
  DesktopContainer,
  FooterAccordionCommonLinkItem,
  FooterAccordionHeaderText,
  FooterAccordionLinks,
  FooterAccordionWrapper,
  MobileContainer,
} from './FooterAccordion.styles';

export type FooterAccordionProps = FooterAccordionSchema;

export function AccordionLinkLabel({ link, label }: { link?: Link; label: LocalizedValue }) {
  const localizedLabel = getLocalizedValue(label);
  return (
    <LinkPartial {...link} ariaLabel={localizedLabel}>
      {localizedLabel}
    </LinkPartial>
  );
}

export function FooterAccordion({ footerColumnTitle, footerAccordionLinks }: FooterAccordionProps) {
  const headerText = getLocalizedValue(footerColumnTitle);

  return (
    <FooterAccordionWrapper>
      <DesktopContainer>
        <FooterAccordionHeaderText>{headerText}</FooterAccordionHeaderText>
        <FooterAccordionLinks>
          {footerAccordionLinks?.map(({ link, label }) => (
            <FooterAccordionCommonLinkItem key={String(label)}>
              <AccordionLinkLabel link={link} label={label} />
            </FooterAccordionCommonLinkItem>
          ))}
        </FooterAccordionLinks>
      </DesktopContainer>
      <MobileContainer>
        <MobileFooterAccordion commonLinks={footerAccordionLinks} title={headerText} />
      </MobileContainer>
    </FooterAccordionWrapper>
  );
}
